import React, { useMemo } from 'react';

import groupBy from 'lodash/groupBy';

import { useSteps } from '~/modules/extension/components/AfterSignUpStepper/constants';
import { useAppSelector } from '~/store/hooks/useAppSelector';

type StepType = {
  order: number;
  isChecked: boolean;
  text: string;
  Button?: () => JSX.Element;
};

const useGetSteps = (
  place: string,
): {
  afterSignUpSteps: StepType[];
  isHasUnCheckedSteps: boolean;
} => {
  const profile = useAppSelector((state) => state.profile);
  const steps = useSteps();
  const isExtensionInstalled = Boolean(
    document.getElementById('justdone-content-app'),
  );

  const preparedSteps = useMemo(() => {
    const filtered = steps
      .filter(({ checkStepVisibility }) => checkStepVisibility())
      .map((step, index) => {
        const StepButton = step.Button;

        return {
          order: index,
          text: step.text,
          isChecked: step.checkState(profile),
          Button: StepButton
            ? (): JSX.Element => <StepButton place={place} />
            : undefined,
        };
      });

    const groupedSteps = groupBy(filtered, 'isChecked');
    const checkedSteps = (groupedSteps['true'] || []) as StepType[];
    const unCheckedSteps = (groupedSteps['false'] || []) as StepType[];

    return [...checkedSteps, ...unCheckedSteps];
  }, [steps, profile, isExtensionInstalled]);

  return {
    afterSignUpSteps: preparedSteps,
    isHasUnCheckedSteps: Boolean(preparedSteps.find((step) => !step.isChecked)),
  };
};

export default useGetSteps;
